import { render } from "./EditTripSchedule.vue?vue&type=template&id=2839579a"
import script from "./EditTripSchedule.vue?vue&type=script&lang=js"
export * from "./EditTripSchedule.vue?vue&type=script&lang=js"
script.render = render

export default script